import { ISortOrder } from "@warda/library-ui/interfaces";
import { INDEX_NAME, } from "../interfaces";
import apiUrls from "./apiUrlsSearch";
import { doAuthenticatedCall } from "./utils/doAuthenticatedCall";
import normalizeEsCatalogs from "../utils/normalizeElasticCatalog";
import { MAX_CATEGORIES, MAX_PAGINATION } from "../constants/keys";
import sortCategories from "../utils/sortCategories";
import { normalizeElasticSrc } from "../utils/es/normalizeElasticSrc";
const getSearchSize = ({ size, aggs }) => {
    if (!!aggs)
        return 0;
    if (size !== undefined)
        return size; // can be 0
    return MAX_PAGINATION;
};
const getSearchFrom = ({ from }) => {
    return from || 0;
};
const getSearchSort = ({ sort }) => {
    return (sort || []).map((s) => {
        const obj = {};
        Object.keys(s).forEach((sKey) => {
            obj[sKey] = {
                ...s[sKey],
                unmapped_type: "keyword",
            };
        });
        return obj;
    });
};
const decorateData = (d) => {
    return {
        ...d,
        track_total_hits: true,
        size: getSearchSize(d),
        from: getSearchFrom(d),
        sort: getSearchSort(d),
    };
};
export const searchEs = async ({ aggregateType, index, data, }) => {
    const response = await doAuthenticatedCall({
        ...apiUrls.searchSc(index),
        data: {
            aggregateType,
            query: decorateData(data),
        },
    });
    return normalizeElasticSrc(response);
};
export const msearchEs = async ({ aggregateType, data, }) => {
    const { responses } = await doAuthenticatedCall({
        ...apiUrls.msearchSc(),
        data: data.map((d) => ({ ...d, aggregateType })),
    });
    return responses.map((r) => normalizeElasticSrc(r));
};
export const getAttributeMainData = async (aggregateType) => {
    const response = await searchEs({
        aggregateType,
        index: INDEX_NAME.CONFIG,
        data: {
            from: 0,
            size: 1,
            query: { ids: { values: ["attribute_structure"] } },
            _source: ["items.id", "items.label", "items.attributeType"],
        },
    });
    return response.items[0].data.items;
};
export const getMediaAlternativeNames = async (aggregateType) => {
    var _a;
    const response = await searchEs({
        aggregateType,
        index: INDEX_NAME.CONFIG,
        data: {
            from: 0,
            size: 1,
            query: { ids: { values: ["media_alternative_names"] } },
            _source: ["items.alternative_name"],
        },
    });
    const items = (_a = response.items[0].data.items) !== null && _a !== void 0 ? _a : [];
    return items.map((a) => a.alternative_name);
};
export const getCatalogs = async (aggregateType) => {
    const response = await searchEs({
        aggregateType,
        index: INDEX_NAME.CATALOGS,
        data: {
            from: 0,
            size: 1000,
            sort: [{ displayOrder: { order: ISortOrder.ASC } }],
        },
    });
    return normalizeEsCatalogs(response.items);
};
export const getCategories = async (aggregateType) => {
    const response = await searchEs({
        aggregateType,
        index: INDEX_NAME.CATEGORIES,
        data: {
            from: 0,
            size: MAX_CATEGORIES,
        },
    });
    return sortCategories(response.items);
};
export const searchEsDashboard = async ({ index, data, }) => {
    const response = await doAuthenticatedCall({
        ...apiUrls.searchDashboard(index),
        data: decorateData(data),
    });
    return normalizeElasticSrc(response);
};
export const searchEsStagingArea = async (data) => {
    const response = await doAuthenticatedCall({
        ...apiUrls.searchStagingArea(),
        data: decorateData(data),
    });
    return normalizeElasticSrc(response);
};
export const searchEsProductMedia = async (data) => {
    const response = await doAuthenticatedCall({
        ...apiUrls.searchProductMedia(),
        data: decorateData(data),
    });
    return normalizeElasticSrc(response);
};
export const searchEsLibraryConfig = async (data) => {
    const response = await doAuthenticatedCall({
        ...apiUrls.searchLibraryConfig(),
        data: decorateData(data),
    });
    return normalizeElasticSrc(response);
};
export const getViews = async (aggregateType) => {
    const response = await searchEs({
        aggregateType,
        index: INDEX_NAME.CONFIG,
        data: {
            from: 0,
            size: 10,
            query: { ids: { values: ["views"] } },
        },
    });
    return response.items[0].data.items || [];
};
